function wowInit() {
  const teeWrapper = document.querySelector('.tee-customization-wrapper');
  if (!teeWrapper) {
    setTimeout(wowInit, 1000);
    return;
  }

  const galleryWrapper = document.querySelector('.tee-gallery-content');
  if (!galleryWrapper) {
    setTimeout(wowInit, 1000);
    return;
  }

  if (document.getElementById('wow-adjust-btn')) return;

  const btn = document.createElement('button');
  btn.innerHTML = '⤢ Ajustează încadrarea';
  btn.id = 'wow-adjust-btn';
  btn.style.cssText = `
    display: none;
    position: absolute;
    bottom: 12px;
    right: 12px;
    z-index: 100;
    border: none;
    cursor: pointer;
    background: rgba(0,0,0,0.6) !important;
    color: #fff !important;
    border-radius: 6px !important;
    padding: 6px 10px !important;
    font-size: 12px !important;
    font-weight: 500;
  `;

  btn.addEventListener('click', function() {
    const teeBtn = document.querySelector('.tee-btn--recustomize');
    if (teeBtn) teeBtn.click();
  });

  galleryWrapper.style.position = 'relative';
  galleryWrapper.appendChild(btn);

  const observer = new MutationObserver(function() {
    const errorSpan = document.querySelector('.tee-photo-error');
    if (errorSpan && errorSpan.textContent.trim() !== '') {
      btn.style.display = 'block';
    } else {
      btn.style.display = 'none';
    }
  });

  observer.observe(teeWrapper, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true
  });
}

// Încearcă imediat și apoi la fiecare secundă până găsește elementele
wowInit();
setTimeout(wowInit, 1000);
setTimeout(wowInit, 2000);
setTimeout(wowInit, 3000);